import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { biHelpCenter } from '../../util/bi';
import { getArticleById } from '../api/getArticleById';
import { getArticleByUri } from '../api/getArticleByUri';
import { useFedopsLogger } from '../providers/fedopsLogger';
import { helpCenterSlice } from '../reducers/helpCenter';

export const useFetchArticle = () => {
  const { articleId, articleUri } = useParams();
  const fedopsLogger = useFedopsLogger();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        dispatch(helpCenterSlice.actions.setCurrentArticleLoading(true));

        fedopsLogger.interactionStarted('fetching-article');
        await (articleId
          ? getArticleById(articleId)
          : getArticleByUri(articleUri!)
        )
          .then((_article) => {
            fedopsLogger.interactionEnded('fetching-article');
            dispatch(helpCenterSlice.actions.setCurrentArticle(_article));
            biHelpCenter.logSingleArticlePresented(
              _article.id,
              _article.locale,
            );
          })
          .finally(() =>
            dispatch(helpCenterSlice.actions.setCurrentArticleLoading(false)),
          );

        dispatch(helpCenterSlice.actions.setArticleHeadingVisible(false));
      } catch (error) {
        // TODO: handle error here
        console.error(error);
      }
    };
    void fetchArticle();

    return () => {
      dispatch(helpCenterSlice.actions.setArticleHeadingVisible(false));
    };
  }, [articleId, articleUri]);
};
